
import React, { Component } from 'react';
import $ from 'jquery';
import home3Imgg from "../images/home3.webp"

export default class Hurdle extends Component {
    render() {

    return (

      <section className="hurdle-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="hurdle-panel"> 
                <div className="home-head">How Ivanooo overcomes these hurdles
                  {/* <p>Seek expert guidance to fix your career/learning pathways.</p> */}
                </div>
                <div className="hurdle-body">
                  <div className="hurdle-box">
                    <div className="hurdle-box-img col-md-5">
                      <img alt="" className="hurdle-img" src={home3Imgg} />
                    </div>
                    <div className="hurdle-box-content col-md-7">
                      <p className="hurdle-box-text">Personalized</p>
                      <p className="hurdle-box-subtext">Our discovery sessions are aimed at drawing out your uniqueness.</p>
                    </div>
                  </div>
                  <div className="hurdle-box">
                    <div className="hurdle-box-img col-md-5 d-md-none">
                      <img alt="" className="hurdle-img" src={home3Imgg} />
                    </div>
                    <div className="hurdle-box-content col-md-7">
                      <p className="hurdle-box-text">Unbiased</p>
                      <p className="hurdle-box-subtext">The courses recommended in our platform are selected through stringent criteria. We are also not attached to any institute, so we don’t need to please others.</p>
                    </div>
                    <div className="hurdle-box-img col-md-5 text-right d-none d-md-block">
                      <img alt="" className="hurdle-img" src={home3Imgg} />
                    </div>
                  </div>
                  <div className="hurdle-box">
                    <div className="hurdle-box-img col-md-5">
                      <img alt="" className="hurdle-img" src={home3Imgg} />
                    </div>
                    <div className="hurdle-box-content col-md-7">
                      <p className="hurdle-box-text">Skill Quotient</p>
                      <p className="hurdle-box-subtext">Our unique S.Q formula takes into consideration your years of experience, hard and soft skills, and academic aptitudes to filter out irrelevant courses from our recommendations.</p>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>
      )
    }
}


// WEBPACK FOOTER //
// ./src/home/hurdle.jsx